import { Amplify } from 'aws-amplify';

export const initAWSAmplify = () => {
  const { REACT_APP_USER_POOL_ID, REACT_APP_BAMBOO_WEB_CLIENT_ID } = import.meta.env;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: REACT_APP_USER_POOL_ID,
        userPoolClientId: REACT_APP_BAMBOO_WEB_CLIENT_ID,
      },
    },
  });
};
